<div class="mvd_alert__validation" type=validation *ngIf="errorMessage">
    <div class="mvd_alert__rule">{{errorMessage}}</div>
</div>
